import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Functionality } from "src/app/shared/constants/functionality.constants";
import { ApiService } from "src/app/shared/services/api.service";
import { PermissionService } from "src/app/shared/services/permission.service";
import { IMlPredictionResult, IPredictionCheckResult } from "../interfaces/predict.interface";

@Injectable({
  providedIn: "root",
})
export class PredictService {
  constructor(
    private api: ApiService,
    private permissionService: PermissionService
  ) {}

  /**
   * Whether the user's role allows running a prediction (see predict()).
   * The backend grants every prediction through the single "/predict" route.
   * @return True if running a prediction is allowed, false otherwise
   */
  public canPredict(): boolean {
    return this.permissionService.isRouteEnabled(Functionality.MAKE_PREDICTION, "POST", "/predict");
  }

  /**
   * Run prediction for a sample
   * @param postgreSQLId The postgreSQL sample id
   * @return The prediction result
   */
  public predict(postgreSQLId: number): Observable<IMlPredictionResult> {
    return this.api.post(`predict/${encodeURIComponent(postgreSQLId)}`, undefined) as Observable<IMlPredictionResult>;
  }

  /**
   * Check if a sample is eligible for prediction
   * @param postgreSQLId The postgreSQL sample id
   * @return Whether the sample is eligible for prediction
   */
  public checkPrediction(sampleId: number): Observable<IPredictionCheckResult> {
    return this.api.get(`predict/${encodeURIComponent(sampleId)}/check`) as Observable<IPredictionCheckResult>;
  }
}
